import React from 'react';
import { AnimatePresence } from 'framer-motion';
import { PaymentStatus } from '@dutchinvoice/types';
import { PaymentStatusBadge } from './PaymentStatusBadge';
import { PaymentStatusPopover } from './PaymentStatusPopover';
import { useClickOutside } from '../../hooks/useClickOutside';

interface PaymentStatusSelectorProps {
  status: PaymentStatus;
  onStatusChange: (status: PaymentStatus) => void;
}

export const PaymentStatusSelector: React.FC<PaymentStatusSelectorProps> = ({
  status,
  onStatusChange,
}) => {
  const [isOpen, setIsOpen] = React.useState(false);
  const containerRef = React.useRef<HTMLDivElement>(null);

  useClickOutside(containerRef, () => setIsOpen(false));

  const handleToggle = React.useCallback(() => {
    setIsOpen(prev => !prev);
  }, []);

  const handleClose = React.useCallback(() => {
    setIsOpen(false);
  }, []);

  return (
    <div className="relative" ref={containerRef}>
      <PaymentStatusBadge
        status={status}
        onClick={handleToggle}
      />
      <AnimatePresence>
        {isOpen && (
          <PaymentStatusPopover
            currentStatus={status}
            onSelect={onStatusChange}
            onClose={handleClose}
          />
        )}
      </AnimatePresence>
    </div>
  );
}; 